function SettingButton({ onClick, active, style='yay', text }) {
    let classes = 'w-12 font-semibold border p-1 text-sm rounded text-neutral-200 transition ';

    switch (style) {
        case 'yay':
            classes += 'border-teal-600 '
            classes += active ? 'bg-teal-500 hover:bg-teal-600 ' : 'bg-neutral-800 ';
            break;
        case 'nay':
            classes += 'bg-neutral-800 border-neutral-600 '
            classes += active ? 'hover:bg-neutral-900 ' : ''
            break;
        case 'slay':
            classes += active ? 'border-purple-600 ' : 'border-teal-600 '
            classes += active ? 'bg-rainbow !text-white font-semibold ' : 'bg-neutral-800 ';
            break;
        case 'flash':
            classes += active ? 'bg-neutral-100 !text-black border-black ' : 'border-teal-600 ';
            break;
        default:
            break;
    }

    return (
        <button className={classes} onClick={onClick} disabled={!active}>{text}</button>
    );
}

export default SettingButton;